import { GET_EVENT_GRAPH_SUCCESS, GET_EVENTS_GRAPH_DATA_SUCCESS, GET_EVENTS_SUCCESS } from './event.types';

const initialState = {
    eventList: [],
    eventsGraph: [],
    eventGraph: {},
};

export const eventsReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Event */

        case GET_EVENTS_SUCCESS:
            return {
                ...state,
                eventList: action.payload,
            };

        case GET_EVENTS_GRAPH_DATA_SUCCESS:
            return {
                ...state,
                eventsGraph: action.payload,
            };

        case GET_EVENT_GRAPH_SUCCESS:
            return {
                ...state,
                eventGraph: action.payload,
            };

        /** End */

        default:
            return state;
    }
};
